import clsx from "clsx";
import styles from "./MapEditor.module.scss";

export default function MapEditor() {
  return <h2 className={clsx(styles.header)}>MAP</h2>;
}
